module.exports = __webpack_public_path__ + "static/3500-quarter-view-4392727c96b0c9f74fa4230364bd871c.jpg";